import api from '../../service/api';
import { useState, useEffect, useContext } from 'react';
import { useParams } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ProgressBar from '../progress/progressBar';
import { Alert, AlertTitle } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import CONSTANT from '../../Constant/Constant';
import {
    Accordion, AccordionSummary,
    AccordionDetails, IconButton, List, ListItem, Divider, Typography, Tooltip,
    Stack,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SingleValue from '../detail-page/base/single-value';
import MultiValue from '../detail-page/base/multi-value';
import { Link as RouterLink } from "react-router-dom";
import Storage from '../../session/storage';
import { DirectionContext } from '../../context/DirectionProvider';
import LillyDcrDetailsField from '../../config/LillyDcrDetailsConfig.json'
import DcrDetailsData from '../../config/DcrDetailsConfig.json'

const RequestsDetail = (props) => {

    const [progressFlag, setProgressFlag] = useState(false);
    const [errorFlag, setErrorFlag] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [requestDetail, setRequestDetail] = useState(undefined);
    const [accordian, setAccordian] = useState(true);
    const [brickAccordian, setBrickAccordian] = useState(true);
    const direction = useContext(DirectionContext);
    const [entity, setEntity]= useState("")
    let { id, mangedBy } = useParams();   
    
    
    
    /**
     * Open/ close Accordian
     * @param {*} prev 
     */
    const closeAccordian = (prev) => {
        setAccordian(!prev)
    }
    /**
     * Back to home 
     */
    const goToHome = () => {
        Storage.setCount(undefined);
        Storage.setAdvanceName(undefined)
        Storage.setGlobalName(undefined)
        props.history.push('');
    }

    /**
     * Back page
     */
    const goBack = () => {
        props.history.goBack();
    }

    /**
     * get status color class
     * @param {*} state 
     * @returns 
     */
    const getStatusClass = (state) => {
        switch (state?.toUpperCase()) {
            case CONSTANT.STATE[0]:
                return 'text-white rounded py-2 px-3 bg-primary float-end';
            case CONSTANT.STATE[1]:
                return 'text-white rounded py-2 px-3 bg-success float-end';
            case CONSTANT.STATE[2]:
                return 'text-white rounded py-2 px-3 bg-danger float-end';
            case CONSTANT.STATE[3]:
                return 'text-white rounded py-2 px-3 bg-warning float-end';
            case CONSTANT.STATE[4]:
                return 'text-white rounded py-2 px-3 bg-primary float-end';
            case CONSTANT.STATE[5]:
                return 'text-white rounded py-2 px-3 bg-success float-end';
            case CONSTANT.STATE[6]:
                return 'text-white rounded py-2 px-3 bg-danger float-end';
            case CONSTANT.STATE[7]:
                return 'text-white rounded py-2 px-3 bg-success float-end';
            case CONSTANT.STATE[8]:
                return 'text-white rounded py-2 px-3 bg-warning float-end';
            case 'AWAITING_REVIEW':
                return 'text-white rounded py-2 px-3 bg-primary float-end';
            case 'PARTIALLY APPROVED':
                return 'text-white rounded py-2 px-3 approvedButton float-end';
            default:
                return 'text-white rounded py-2 px-3 bg-primary float-end';
        }
    }

    /**
     * Map response
     * @param {*} data 
     * @returns mapped value
     */
    const mapResponse = (data) => {
        if (data.updates && data.updates.create_entity) {
            data.updates.create_entity = data.updates.create_entity.map((value) => {

                if (value.Address !== undefined) {
                    return ({
                        ...value,
                        Address: {
                            AddressLine1: value.Address[0].AddressLine1,
                            City: value.Address[0].City,
                            StateProvince: value.Address[0].StateProvince,
                            Zip: value.Address[0].Zip,
                            Country: value.Address[0].Country ? value.Address[0].Country : []
                        }
                    })
                } else {
                    return value;
                }
            })

        }
        return data;

    }

    const getAddressValue = (addressList) => {
        // remove the address fields which are not present in DCRDetailsData.address
        let filteredAddressList = addressList.map(address => {
            let filteredAddress = {};
            Object.keys(DcrDetailsData.Address).forEach(key => {
                if (address[key]) {
                    filteredAddress[key] = address[key];
                }
            })
            // Preserve BRICK data so it can be rendered as a collapsible accordion
            if (address?.BRICK?.[0]) {
                filteredAddress.BRICK = address.BRICK;
            }
            return filteredAddress;
        })
        return filteredAddressList;
    }

    const getReviewerComments = (comments) => {
        let revierCommentsList = comments.split('.;');

        return revierCommentsList.map((comment, index) => (
            <ul key={index}>
                <li className='ms-2'>{comment}</li>
            </ul>
        ));
    }

    const getEntityLabel = () => {
        if(requestDetail.UpdatedValues?.Entity.type === "configuration/entityTypes/HCP" && requestDetail.UpdatedValues?.Entity.label){
            return requestDetail.UpdatedValues.Entity.label
        }
        else if(requestDetail.UpdatedValues?.Entity.hasOwnProperty('FirstName')){
            return requestDetail.UpdatedValues.Entity.FirstName[0].value+" "+requestDetail.UpdatedValues.Entity.LastName[0].value
        }else if(requestDetail.UpdatedValues?.Entity.type === "configuration/entityTypes/HCO" && requestDetail.UpdatedValues?.Entity.label){
            return requestDetail.UpdatedValues.Entity.label
        }
        else if(requestDetail.UpdatedValues?.Entity.hasOwnProperty('Name')){
            return requestDetail.UpdatedValues.Entity.Name[0].value
        }
        else
            return "No Label"
    }

    const getHcoLabel = () => {
        if(requestDetail.UpdatedValues?.Entity.type === "configuration/entityTypes/HCO" && requestDetail.UpdatedValues?.Entity.label){
            return  requestDetail.UpdatedValues.Entity.label
        }
        else if(requestDetail.UpdatedValues?.Relations && requestDetail.UpdatedValues?.Relations.length > 0 && requestDetail.UpdatedValues?.Relations[0].hasOwnProperty('label')){
            return requestDetail.UpdatedValues.Relations[0].label
        }
        else if(requestDetail.UpdatedValues?.Relations && requestDetail.UpdatedValues?.Relations.length > 0 && requestDetail.UpdatedValues?.Relations[0].hasOwnProperty('Name')){
            return requestDetail.UpdatedValues.Relations[0].Name[0].value
        }
        else
            return "No Label"
    }

    useEffect(() => {
        setProgressFlag(true);       
           
        api.getAllRequest(false, null, id).then((res) => {
            if(res.data.UpdatedValues.Entity.type === "configuration/entityTypes/HCO"){
                setEntity("HCO")
            }else {setEntity("HCP")}
            setRequestDetail(mapResponse(res.data));           
            setErrorFlag(false)
            setProgressFlag(false);
        }).catch((error) => {
           setErrorFlag(true);
                let errorDetail = error;
                let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';
                setErrorMsg(msg ? msg : 'Internal Server Error!');
                setProgressFlag(false)
            })        
 
                
        

    }, [id])
    return (

        <section className={"container w-80 body-height extra-margin-top-less"}>
            {
                progressFlag
                &&
                <div className="d-flex justify-content-center extra-margin-top">
                    <ProgressBar />
                </div>
            }

            {
                !progressFlag && !errorFlag && requestDetail &&
                <>
                    <div className='container'>

                        {
                            <div className='row mt-5 mb-5'>
                               <Stack 
                                    direction={'row'}
                                    alignItems={'center'}
                                    justifyContent={'space-between'}
                                >
                                    <Tooltip disableFocusListener title="Back" id="tooltip">
                                        <IconButton aria-label="delete"
                                            className="text-danger float-start"
                                            onClick={goBack} color="secondary">
                                            <ArrowBackIcon sx={{ transform: direction==='rtl'? 'rotate(180deg)':''}}/>
                                        </IconButton>
                                    </Tooltip>

                                    <IconButton aria-label="delete " onClick={goToHome} className=' float-end'
                                        color="secondary">
                                        <Tooltip disableFocusListener title="Return To Home" id="tooltip">
                                            <HomeIcon className="text-danger "
                                            />
                                        </Tooltip>
                                    </IconButton>
                                </Stack>
                                <Stack
                                    direction={'row'}
                                    alignItems={'center'}
                                    justifyContent={'space-between'}
                                    margin={" 10px 0"}
                                >
                                    <Typography variant='subtitle1' className='fw-bold' id='request-header'>
                                        Requested Changes
                                    </Typography>
                                    {!requestDetail.NewLlyDcrStructure?
                                    <span data-wg-notranslate className={getStatusClass(requestDetail.state.trim() || requestDetail.DcrStatus.trim())}>
                                        {requestDetail.state === 'AWAITING_REVIEW' ? 'AWAITING REVIEW': requestDetail.state ||  requestDetail.DcrStatus } 
                                    </span>
                                    :<span data-wg-notranslate className={getStatusClass(requestDetail.DcrStatus.trim())}>
                                    {requestDetail.DcrStatus === 'AWAITING_REVIEW' ? 'AWAITING REVIEW': requestDetail.DcrStatus} 
                                    </span>
                                    }
                                </Stack>

                                <List component="div" className='row'>
                                    {
                                        <>
                                            <ListItem className='col-6'>
                                                <SingleValue label={'Managed By'} value={[{ value: mangedBy }]} />
                                            </ListItem>
                                            <ListItem className='col-6'>
                                                <SingleValue label={'Request Id'} value={[{ value: requestDetail.Id }]} />
                                            </ListItem>
                                            {
                                                mangedBy && mangedBy === 'OPEN-DATA' && requestDetail?.HcpVid  &&
                                                <ListItem className='col-6'>
                                                    <SingleValue label={'HCP VId'} value={[{ value: requestDetail?.HcpVid }]} />
                                                </ListItem>
                                            }
                                            {requestDetail?.HcpEntityId &&
                                                <ListItem className='col-6'>
                                                    <SingleValue label={'HCP Entity Id'} value={[{ value: requestDetail.HcpEntityId }]} />
                                                </ListItem>
                                            }
                                            {(requestDetail?.HcoEntityId || requestDetail?.StandaloneHcoEntityId) &&
                                                <ListItem className='col-6'>
                                                    <SingleValue label={'HCO Entity Id'} value={[{ value: requestDetail.StandaloneHcoEntityId ? requestDetail.StandaloneHcoEntityId : requestDetail.HcoEntityId }]} />
                                                </ListItem>
                                            }
                                            {requestDetail?.entityid &&
                                                <ListItem className='col-6'>
                                                    <SingleValue label={'Entity Id'} value={[{ value: requestDetail.entityid }]} />
                                                </ListItem>
                                            }
                                            {
                                                requestDetail?.HcpUniqueId &&
                                                <ListItem className='col-6'>
                                                    <SingleValue label={'HCP Unique Id'} value={[{ value: requestDetail.HcpUniqueId }]} />
                                                </ListItem>
                                            }
                                            {
                                                (requestDetail?.StandaloneHcoUniqueId || requestDetail?.HcoUniqueId) &&
                                                <ListItem className='col-6'>
                                                    <SingleValue label={'HCO Unique Id'} value={[{ value: requestDetail?.StandaloneHcoUniqueId ? requestDetail.StandaloneHcoUniqueId : requestDetail.HcoUniqueId }]} />
                                                </ListItem>
                                            }
                                            <ListItem className='col-6'>
                                                <SingleValue label={'Requester Id'} value={[{ value: requestDetail.CreatedBy}]} />
                                            </ListItem>
                                            <ListItem className='col-6'>
                                                <SingleValue label={'Requester Name'} value={[{ value:requestDetail?.RequestorName ? requestDetail.RequestorName.includes(" - Network") ? requestDetail.RequestorName.split(" - Network")[0].trim(): requestDetail.RequestorName : 'N/A' }]} />
                                            </ListItem>
                                            <ListItem className='col-6'>
                                                <SingleValue label={'Requester Email'} value={[{ value:  requestDetail?.RequestorEmail ? requestDetail.RequestorEmail : 'N/A'  }]} />
                                            </ListItem>
                                            <ListItem className='col-6'>
                                                <SingleValue label={'Created Time'} value={[{ value: requestDetail.CreatedDate }]} />
                                            </ListItem>        
                                                <ListItem className='col-6'>
                                                    <SingleValue label={'Updated Time'} value={[{ value: requestDetail.UpdatedDate }]} />
                                                </ListItem>
                                            {
                                                requestDetail.comments || requestDetail.DcrComments?
                                                <>
                                                    <ListItem className='col-6'>
                                                        <Typography variant='subtitle1' className='fw-bold' id="request-header" style={{textWrap:'nowrap'}}>Requestor Comment :</Typography>
                                                        <span className='ms-2'>
                                                            {requestDetail.comments || requestDetail.DcrComments}
                                                        </span>
                                                    </ListItem>
                                                </>:''
                                            }
                                            {
                                                requestDetail.ReviewerComments?
                                                <>
                                                    <ListItem className='col-6 d-flex align-items-start'>
                                                        <Typography variant='subtitle1' className='fw-bold' id="request-header" style={{textWrap:'nowrap'}}>Reviewer Comment :</Typography>
                                                        <span className='ms-2'>
                                                            {getReviewerComments(requestDetail.ReviewerComments)}
                                                        </span>
                                                    </ListItem>
                                                </>:''
                                            }
                                            <ListItem className='col-6'>
                                                <Typography variant='subtitle1' className='fw-bold' id="request-header">Attribute Changes :</Typography>

                                            </ListItem>
                                            <Divider />
                                        </>
                                    }
                                    <div className='border py-3 container px-4'>
                                        {
                                            requestDetail.updates && requestDetail.updates.update_entity !== undefined && Object.keys(requestDetail.updates.update_entity).map((attribute, i) => {
                                                let value = requestDetail.updates.update_entity[attribute];
                                                if (value.length > 0 && value[0].value === undefined) {
                                                    return '';
                                                } else {
                                                    return (
                                                        <div key={i}>
                                                            <ListItem className='col-6' >
                                                                <SingleValue label={attribute.replace(/([a-z])([A-Z])/g, '$1 $2')} value={value}/>
                                                            </ListItem>
                                                            <Divider />
                                                        </div>
                                                    )
                                                }
                                            }
                                            )}
                                            {((requestDetail?.UpdatedValues?.Entity['NewSpecialities'] && Object.keys(requestDetail?.UpdatedValues?.Entity['NewSpecialities']).length > 0) || requestDetail?.UpdatedValues?.Entity['NewIdentifiers']?.filter(val => val?.AddedNew)?.length > 0) && <><Typography variant='subtitle1' className='fw-bold pb-3' id="request-header">Additions :</Typography>
                                            <div className='border py-3 container px-4'>
                                                {
                                                    (requestDetail.NewLlyDcrStructure || requestDetail.VendorName == 'OPEN-DATA') && requestDetail.UpdatedValues?.Entity && (
                                                        Object.values(LillyDcrDetailsField[requestDetail.UpdatedValues.Entity.type.split('/')[2]]).map((attribute, i) => {
                                                            let value = requestDetail.UpdatedValues.Entity[attribute.key];
                                                            let attributePresent = requestDetail.UpdatedValues.Entity.hasOwnProperty(attribute.key)
                                                            value = Array.isArray(value) ? value : [{ 'value': value }]
                                                            // let fieldName = attribute.key.charAt(0).toUpperCase() + attribute.key.slice(1);
                                                            if (attribute.key==='NewSpecialities' && attributePresent) {
                                                                let objectLen = Object.keys(value[0].value).length
                                                                if(objectLen !== 0){
                                                                    return (
                                                                        <MultiValue noSearch={true} key={i} heading={value[0].value?.PrimarySpecialty ? 'PrimarySpecialty' : 'OtherSpecialty'} label={"Specialities"} value={[value[0].value]} />
                                                                    )
                                                                }
                                                            }
                                                            else if ((attribute.key === 'NewIdentifiers') && value?.filter(val => val?.AddedNew)?.length > 0 && attributePresent) {
                                                                return (
                                                                    <MultiValue noSearch={true} key={i} heading={'Type&ID'} label={"Identifiers"} value={value?.filter(val => val?.AddedNew)} />
                                                                )
                                                            }
                                                            else return null
                                                        })
                                                    )
                                                }
                                            </div></>
                                            }
                                            <Typography variant='subtitle1' className='fw-bold pb-3' id="request-header">Updates :</Typography>
                                            <div className='border py-3 container px-4'>
                                                {
                                                (requestDetail.NewLlyDcrStructure || requestDetail.VendorName == 'OPEN-DATA') && requestDetail.UpdatedValues?.Entity && (
                                                    Object.values(LillyDcrDetailsField[requestDetail.UpdatedValues.Entity.type.split('/')[2]]).map((attribute, i) => {
                                                        let value = requestDetail.UpdatedValues.Entity[attribute.key];
                                                        let attributePresent = requestDetail.UpdatedValues.Entity.hasOwnProperty(attribute.key)
                                                        value = Array.isArray(value) ? value : [{ 'value': value }]
                                                        let fieldName = attribute.key.charAt(0).toUpperCase() + attribute.key.slice(1);
                                                        if (attribute.key === 'Specialities' && attributePresent && value.filter(val => val?.isDeleted || (val?.Rank[0]?.value == "99"))?.length > 0) {
                                                            return (
                                                                <MultiValue noSearch={true} key={i} heading={'Specialty'} label={"Specialities"} value={value.filter(val => val?.isDeleted || (val?.Rank[0]?.value == "99"))} />
                                                            )
                                                        }
                                                        else if ((attribute.key === 'NewIdentifiers') && value?.filter(val => val?.Deactivated)?.length > 0 && attributePresent) {
                                                            return (
                                                                <MultiValue noSearch={true} key={i} heading={'Type&ID'} label={"Identifiers"} value={value?.filter(val => val?.Deactivated)} />
                                                            )
                                                        }
                                                        else if (attribute.key === 'Address' && value[0]?.AddressLine1 && attributePresent) {
                                                            return (
                                                                <MultiValue noSearch={true} showBrick={true} key={i} label="Address" heading={'AddressLine1&City&Country'} value={getAddressValue(value)} />
                                                            )
                                                        }
                                                        else {
                                                            return (
                                                                (attribute.key !== "Email" && attribute.key !== "Phone" && attribute.key !== "False" && attribute.key !== "Specialities" && attribute.key !== "NewSpecialities" && !attribute.label && value.length > 0 && value[0]['value'] != undefined) ?
                                                                    (<div key={i}>
                                                                        <ListItem className='col-6' >
                                                                            {attribute.key !== "type" &&
                                                                                <SingleValue label={fieldName.replace(/([a-z])([A-Z])/g, '$1 $2')} value={value} />
                                                                            }
                                                                            {attribute.key == "type" &&
                                                                                <SingleValue label={fieldName.replace(/([a-z])([A-Z])/g, '$1 $2')} value={[{ value: value[0]['value'].split('/')[2] }]} />
                                                                            }
                                                                        </ListItem>
                                                                        <Divider />
                                                                    </div>
                                                                    ) : '')
                                                        }
                                                    })
                                                )
                                            }
                                            </div>
                                        {
                                            requestDetail?.updates && requestDetail?.updates?.update_entity !== undefined && Object.keys(requestDetail.updates.update_entity).map((attribute, i) => {
                                                let value = requestDetail.updates.update_entity[attribute];
                                                if (value.length > 0 && value[0].value === undefined) {
                                                    if (attribute === 'Specialities') {
                                                        return (
                                                            <MultiValue noSearch={true} key={i} heading={'Specialty'} label={"Specialities"} value={value} />
                                                        )
                                                    }
                                                    else if (attribute === 'Identifiers') {
                                                        return (
                                                            <MultiValue noSearch={true} key={i} heading={'Type&ID'} label={"Identifiers"} value={value} />
                                                        )
                                                    }
                                                    else if (attribute === 'Merge_profile') {
                                                        return (
                                                            <MultiValue noSearch={true} key={i} heading={'Type&ID'} label={"Identifiers"} value={value} />
                                                        )
                                                    }
                                                    else if (attribute === 'Address' && value[0].AddressLine1) {
                                                        return (
                                                            <MultiValue noSearch={true} key={i} label="Address" heading={'AddressLine1&City&Country'} value={getAddressValue(value)} />
                                                        )

                                                    }
                                                    return '';
                                                } else {
                                                    return ''
                                                }
                                            }
                                            )
                                        }

                                        {
                                            requestDetail.updates && requestDetail.updates.create_entity !== undefined &&
                                            requestDetail.updates.create_entity.map((value, i) => {
                                                return (
                                                    <div key={i} className='border p-3'>
                                                        <Typography variant='subtitle1' className='fw-bold'>{value.type.split('/')[2] === 'HCP' ? 'Entity' : 'Relation'}</Typography>
                                                        <SingleValue label={'Prefix'} value={value.Prefix} />
                                                        <SingleValue label={'First Name'} value={value.FirstName} />
                                                        <SingleValue label={'Middle Name'} value={value.MiddleName} />
                                                        <SingleValue label={'Last Name'} value={value.LastName} />
                                                        <SingleValue label={'Secondary Last Name'} value={value.SecondaryLastName} />
                                                        <SingleValue label={'Gender'} value={value.Gender} />
                                                        <SingleValue label={'Classification Code'} value={value.ClassificationCode} />
                                                        <SingleValue label={'Country Code'} value={value.CountryCode} />
                                                        <SingleValue label={'HCO'} value={value.Name} />
                                                        {value?.Address !== undefined && value[0]?.AddressLine1 && <MultiValue noSearch={true} label="Address" heading={'AddressLine1&City&Country'} value={value.Address} />}
                                                        {value.Specialities && <MultiValue noSearch={true} label={"Specialities"} heading={'Specialty'} value={value.Specialities} />}
                                                    </div>
                                                )
                                            })
                                        }

                                        {
                                            requestDetail.updates && requestDetail.updates.create_relations.length > 0 &&
                                            <Accordion square className="shadow-none col-12" expanded={accordian}>
                                                <AccordionSummary onClick={() => closeAccordian(accordian)}
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="FirstName"
                                                    className='bg-grey'
                                                >
                                                    <Typography variant='subtitle1' className='fw-bold' id="request-header"> Relation</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails className='border row'>
                                                    {
                                                        requestDetail.updates.create_relations.map((relation,id) => {
                                                            return (
                                                                <div className='border' key={id}>
                                                                    <div className='col-12 mt-2 text-muted '>
                                                                        <span dir={direction} id="request-header" className='text-dark'> HCP : </span>
                                                                        <RouterLink
                                                                            to={'/details/' + relation?.startObjectURI + '/' + relation?.startObjectType?.split('/')[2]}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer" className=" pl-3 mb-0">
                                                                            {relation.startObjectLabel}
                                                                        </RouterLink>
                                                                    </div>
                                                                    <div className='col-12 mt-3 text-muted '>
                                                                        <span dir={direction} className='text-dark'> HCO : </span>
                                                                        <RouterLink
                                                                            to={'/details/' + relation?.endObjectURI + '/' + relation?.endObjectType?.split('/')[2]}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer" className=" pl-3 mb-0">
                                                                            {relation?.endObjectLabel}
                                                                        </RouterLink>
                                                                    </div>
                                                                </div>

                                                            )
                                                        })
                                                    }
                                                </AccordionDetails>
                                            </Accordion>
                                        }
                                        {

                                            (requestDetail.NewLlyDcrStructure && (requestDetail.UpdatedValues?.Entity !== "" && requestDetail.UpdatedValues?.Relations?.length > 0 ) )?
                                            <Accordion square className="shadow-none col-12" expanded={accordian}>
                                                <AccordionSummary onClick={() => closeAccordian(accordian)}
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="FirstName"
                                                    className='bg-grey'
                                                >
                                                    <Typography variant='subtitle1' className='fw-bold' id="request-header"> Relation</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails className='border row'>
                                                    {
                                                                <div className='border' key={id}>
                                                                    <div className='col-12 mt-2 text-muted '>
                                                                        <span dir={direction} id="request-header" className='text-dark'> {entity} : </span>
                                                                        {requestDetail?.UpdatedValues && requestDetail?.UpdatedValues?.Entity && requestDetail?.UpdatedValues?.Entity?.uri ?
                                                                        <RouterLink
                                                                            to = {'/details/' + requestDetail?.UpdatedValues?.Entity?.uri + '/' + entity}
                                                                            target={"_blank"}
                                                                            rel="noopener noreferrer" className=" pl-3 mb-0">
                                                                            {getEntityLabel()}
                                                                        </RouterLink>
                                                                        :
                                                                        <span dir={direction} id="request-header"> {getEntityLabel()} </span>
                                                                        }
                                                                    </div>
                                                                    <div className='col-12 mt-3 text-muted mb-2'>
                                                                        <span dir={direction} className='text-dark'> HCO : </span>
                                                                        {requestDetail?.UpdatedValues && requestDetail?.UpdatedValues?.Relations && requestDetail?.UpdatedValues?.Relations?.length > 0 && requestDetail?.UpdatedValues?.Relations[0]?.uri ?
                                                                        <RouterLink
                                                                            to = {'/details/' + requestDetail?.UpdatedValues?.Relations[0]?.uri + '/' + 'HCO'}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer" className=" pl-3 mb-0">
                                                                            {getHcoLabel()}
                                                                        </RouterLink>
                                                                        :
                                                                        <span dir={direction} id="request-header"> {getHcoLabel()} </span>
                                                                        }   
                                                                    </div>
                                                                    
                                                                    {(() => {
                                                                        // render selected relation fields in a safe, normalized way
                                                                        const relation = requestDetail.UpdatedValues?.Relations?.[0];
                                                                        if (!relation) return null;
                                                                        const keysToShow = ["Name", "RelationTypeCode", "ClassificationCode", "Vid", "ActiveFlag", "Address"];

                                                                        // helper to normalize a value into the expected array shape
                                                                        const normalize = (v) => {
                                                                            if (Array.isArray(v)) return v;
                                                                            if (v == null) return [];
                                                                            if (typeof v === 'object') return [v];
                                                                            return [{ value: v }];
                                                                        };

                                                                        return (
                                                                            <>
                                                                                {keysToShow.map((key) => {
                                                                                    if (!Object.prototype.hasOwnProperty.call(relation, key)) return null;
                                                                                    const val = relation[key];

                                                                                    if (key === 'Address') {
                                                                                        if (!Array.isArray(val)) return null;
                                                                                        if (relation?.IsNew) {
                                                                                            const firstAddr = val[0] || {};
                                                                                            return Object.entries(firstAddr).map(([subKey, subValue]) => {
                                                                                                const normalized = normalize(subValue);
                                                                                                const checkFalgs = !["IsEdited", "IsNew", "BRICK"].includes(subKey)

                                                                                                if(checkFalgs){

                                                                                                    return (
                                                                                                        <SingleValue
                                                                                                        key={`relation-${key}-${subKey}`}
                                                                                                        label={subKey.replace(/([a-z])([A-Z])/g, '$1 $2')}
                                                                                                        value={normalized}
                                                                                                        />
                                                                                                    );
                                                                                                }
                                                                                                return null;
                                                                            });
                                                                                        }

                                                                                        return (
                                                                                            <SingleValue
                                                                                                key={`relation-${key}`}
                                                                                                label={'Address'}
                                                                                                value={normalize(val)}
                                                                                            />
                                                                                        );
                                                                                    }

                                                                                    const normalized = normalize(val);
                                                                                    return (
                                                                                        <SingleValue
                                                                                            key={`relation-${key}`}
                                                                                            label={key.replace(/([a-z])([A-Z])/g, '$1 $2')}
                                                                                            value={normalized}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                            {/* Render BRICK details as collapsible accordion if present in the first address */}
                                                                            {(() => {
                                                                                return relation?.IsNew && relation.Address && Array.isArray(relation.Address) && relation.Address[0]?.BRICK && (
                                                                                    (() => {
                                                                                        const brickArr = Array.isArray(relation.Address[0].BRICK) ? relation.Address[0].BRICK : [relation.Address[0].BRICK];
                                                                                        const brickObj = brickArr[0] || {};
                                                                                        const brickEntries = Object.entries(brickObj);
                                                                                        if (brickEntries.length === 0) return null;
                                                                                        return (
                                                                                            <Accordion square className="shadow-none col-12 mt-2" expanded={brickAccordian}>
                                                                                                <AccordionSummary
                                                                                                    onClick={() => setBrickAccordian(prev => !prev)}
                                                                                                    expandIcon={<ExpandMoreIcon />}
                                                                                                    aria-controls="brick-content"
                                                                                                    id="brick-header"
                                                                                                    className='bg-grey'
                                                                                                >
                                                                                                    <Typography variant='subtitle2' className='fw-bold' id="request-header">BRICK</Typography>
                                                                                                </AccordionSummary>
                                                                                                <AccordionDetails>
                                                                                                    {brickEntries.map(([brickKey, brickVal]) => {
                                                                                                        const normalized = normalize(brickVal);
                                                                                                        return (
                                                                                                            <SingleValue
                                                                                                                key={`relation-brick-${brickKey}`}
                                                                                                                label={brickKey.replace(/([a-z])([A-Z])/g, '$1 $2')}
                                                                                                                value={normalized}
                                                                                                            />
                                                                                                        );
                                                                                                    })}
                                                                                                </AccordionDetails>
                                                                                            </Accordion>
                                                                                        );
                                                                                    })()
                                                                                );
                                                                            })()}
                                                                            </>
                                                                        );
                                                                    })()}
                                                                </div>
                                                    }
                                                </AccordionDetails>
                                            </Accordion>:''
                                        }
                                    </div>
                                </List>

                            </div>

                        }

                    </div>

                </>
            }

            {
                errorFlag
                &&
                <div className="d-flex justify-content-center extra-margin-top">
                    <Alert severity="error" className='container'>
                        <AlertTitle>{errorMsg} !</AlertTitle>
                    </Alert>
                </div>
            }

        </section>
    )
}

export default RequestsDetail;